import {environment} from '../../environments/environment';
import {appVersion} from '../../environments/version';

// ira-groupnet.app と同形: 向き先は environments/environment.{ts,stage.ts,prod.ts} で切替。
// - domain: SPA を配信する host。apiDomain: backend/OrientDB のエンドポイント host。
//   apiDomain 未指定 (空) なら従来どおり domain と同じ (同一 origin、CORS 不要)。
//   移行期間中は SPA を旧サーバ (旧 DNS) から配信しつつ API だけ新 backend
//   (dev.active-promotion.jp / active-promotion.jp) に向けるため別指定する。
//   cross-origin になるので backend の CORS_ALLOWED_ORIGINS と deployment 側
//   orientdb router の CORS 設定が前提。WebSocket も apiDomain の /server 配下。
// - dev (environment.ts): remote=false、window.location 由来 (traefik port 80 経由、
//   ng serve 直叩きは proxy.conf.json)
export class ActivePromotionConfig {
    public static debug = false;
    public static remote = environment.remote;
    public static DOMAIN = environment.domain;
    public static API_DOMAIN = environment.apiDomain || environment.domain;
    public static PORT = ActivePromotionConfig.remote ? '443' : '80';
    public static DATABASE = environment.database || 'digital-auction';
    public static SERVER_URL = ActivePromotionConfig.remote ? 'https://' + ActivePromotionConfig.API_DOMAIN + ':' + ActivePromotionConfig.PORT + '/server' : window.location.protocol + '//' + ActivePromotionConfig.API_DOMAIN + '/server';
    public static DATABASE_URL = ActivePromotionConfig.remote ? 'https://' + ActivePromotionConfig.API_DOMAIN + ':' + ActivePromotionConfig.PORT + '/api' : window.location.protocol + '//' + ActivePromotionConfig.API_DOMAIN + '/api';
    // 出品画像。旧構成では SPA と同 host の /images/ を静的配信していた (配信元は
    // SPA 側 host のまま。新構成での配信元は deployment 側で要整備)。
    public static IMAGE_URL = ActivePromotionConfig.remote ? 'https://' + ActivePromotionConfig.DOMAIN + ':' + ActivePromotionConfig.PORT + '/images/' : window.location.protocol + '//' + ActivePromotionConfig.DOMAIN + '/images/';
    public static WS_URL = ActivePromotionConfig.remote ? 'wss://' + ActivePromotionConfig.API_DOMAIN + ':443/server' : 'ws://' + ActivePromotionConfig.API_DOMAIN + '/server';
    public static PREFIX = '.';
    public static VERSION = appVersion;
}
